import { MenuItem } from "@mui/material";
import { materialStatusList } from "../../../client/AllEquipments/CommonFeatures/MCS3/vars";

const mainCols = [
  {
    accessorKey: "time",
    header: "Delivery (in days)",
    Header: () => {
      return (
        <div>
          <div style={{ textAlign: "center" }}>Delivery</div>
          <div style={{ textAlign: "center" }}>(in days)</div>
        </div>
      );
    },
    size: 100,
  },
  {
    accessorKey: "cost",
    header: "Cost / Unit (Dollar$)",
    Header: () => {
      return (
        <div>
          <div style={{ textAlign: "center" }}>Cost / Unit</div>
          <div style={{ textAlign: "center" }}>(Dollar $)</div>
        </div>
      );
    },
    size: 100,
  },

  // {
  //   accessorKey: "status",
  //   header: "Status",
  //   size: 100,
  //   muiEditTextFieldProps: () => ({
  //     children: materialStatusList.map((n) => (
  //       <MenuItem key={n} value={n}>
  //         {n}
  //       </MenuItem>
  //     )),
  //     select: true,
  //   }),
  //   enableEditing: true,
  // },
];
export const taggedCols = [
  {
    accessorKey: "tagNumber",
    header: "TagNumber",
  },
  {
    accessorKey: "materialCode",
    header: "Material Code",
  },
  ...mainCols,
];

export const bulkedCols = [
  // {
  //   accessorKey: "materialCode",
  //   header: "Material Code",
  // },
  {
    accessorKey: "costCode",
    header: "Cost Code",
    size: 90,
    // minWidth: 100,
    enableEditing: false,
  },
  {
    accessorKey: "description",
    header: "Material Description",
    size: 400,
    enableEditing: false,
  },
  {
    accessorKey: "quantity",
    header: "Quantity",
    size: 50,
    // minWidth: 100,
    enableEditing: false,
  },
  {
    accessorKey: "weight",
    header: "Total Weight",
    size: 70,
    // minWidth: 100,
    enableEditing: false,
    Cell: ({ row }) => {
      const weight = row.original?.weight;

      function formatNumber(num) {
        return Number.isInteger(num) ? num : num.toFixed(2);
      }

      return formatNumber(Number(weight));
    },
  },
  ...mainCols,
];
